module.exports = __webpack_public_path__ + "static/media/full-btn@2x.db8a819f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/full-btn@2x.png
// module id = 897
// module chunks = 0